import type {VoiceLanguage} from '@Panels/ai-voice-panel/ai-voice-panel.types';

export interface VoiceLanguageSelectorProps {
  selectedLanguage: VoiceLanguage;
  onLanguageSelected: (language: VoiceLanguage) => void;
}

export const VOICE_LANGUAGE_SELECTOR_MODAL_PANEL_ID = 'ai-voice-language-selector-modal';
export const VOICE_ACCENT_MODAL_HEIGHT = '460px';
